
var nav = jQuery('.ct_navigation.main .navbar-collapse');
jQuery(window).on('load resize', topOfMobileNav);

function isNavSmallBreakpoint() {
    console.log(bootstrapDetectBreakpoint());
    return (bootstrapDetectBreakpoint() == 'xs' ||
            bootstrapDetectBreakpoint() == 'sm' ||
            bootstrapDetectBreakpoint() == 'md');
}

function topOfMobileNav() {
    if (isNavSmallBreakpoint()) {
        nav.css('top', jQuery('header').outerHeight()-1);
    } else {
        nav.css('top', 'auto');
    }
}

/* click handler */
jQuery('.navbar-toggler').on('click', function (event) {
    if (isNavSmallBreakpoint()) {
        event.preventDefault();
        nav.toggleClass('show');
        jQuery("html").toggleClass('overflow-hidden', nav.hasClass('show'));
        jQuery(".ct-header-wrapper").toggleClass('ct-mobile-nav-open', nav.hasClass('show'));
        event.stopPropagation();
    }
});

// Sticky header
jQuery(document).on('scroll', function (event) {
    jQuery(".ct-header-wrapper").toggleClass("ct-header-sticky", jQuery(window).scrollTop() > 0);
});
